import { Record } from 'immutable';

export interface SelectionInterface {
  selection: Array<string>;
  selectAll: boolean;
}

export const initialState: SelectionInterface = {
  selection: new Array(),
  selectAll: false,
};

export default class SelectionState extends Record(initialState) { }
